import router from "@/router";
import {
  ApolloClient,
  ApolloLink,
  HttpLink,
  InMemoryCache,
} from "@apollo/client/core";
import { onError } from "@apollo/client/link/error";
import { apiUrl } from "./environment";
// import { createApolloProvider } from '@vue/apollo-option'

const httpLink = new HttpLink({
  uri: `${apiUrl}/graphql`,
});

const middlewareLink = new ApolloLink((operation, forward) => {
  const token = localStorage.getItem("auth_token");
  if (token) {
    operation.setContext({
      headers: {
        Authorization: token,
      },
    });
  }
  return forward(operation);
});

const errorLink = onError(({ graphQLErrors }) => {
  if (
    graphQLErrors?.some(
      ({ extensions }) => extensions?.code === "UNAUTHENTICATED"
    )
  ) {
    router.push("/auth/login");
  }
  if (
    graphQLErrors?.some(
      ({ extensions }) => extensions?.code === "SUBSCRIPTION_EXPIRED"
    )
  ) {
    router.push("/user/subscriptions");
  }
});

const link = middlewareLink.concat(errorLink).concat(httpLink);

// Create the apollo client
export const apolloClient = new ApolloClient({
  link,
  cache: new InMemoryCache(),
  connectToDevTools: true,
});

// const apolloProvider = createApolloProvider({
//     defaultClient: apolloClient,
// })
